import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { useSlotGroup, EditableSlotGroup } from '@vibesites/runtime/react';
import { VibesitesImage } from '@vibesites/ui-primitives';

/**
 * Deals page promo image — sits below the shared PageBlurb, matching the
 * simple blurb + content layout used on other inner pages.
 */

const imageDef: SlotGroupDefinition = {
  label: 'Promo Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultValue: '',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'CORT furniture rental deals',
    },
  },
};

export function Deals() {
  const image = useSlotGroup('deals.image', imageDef);

  return (
    <section className="bg-background py-2 pb-12 md:py-3 md:pb-16">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <EditableSlotGroup groupPath="deals.image" definition={imageDef}>
          {image.image ? (
            <VibesitesImage
              url={image.image}
              alt={image.alt || 'CORT furniture rental deals'}
              className="h-auto w-full"
              sizes="(max-width: 768px) 100vw, 768px"
            />
          ) : (
            <div
              className="aspect-[4/5] w-full bg-muted"
              aria-label="Promo image placeholder"
            />
          )}
        </EditableSlotGroup>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'Deals',
  displayName: 'Deals',
  tokens: {},
  slotGroups: {
    'deals.image': imageDef,
  },
};

(Deals as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default Deals;
